// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2m6uV","info":"Note_info__2VGfV","note":"Note_note__nxvUt","actions":"Note_actions__mxbz6"};